// import React, { useEffect, useRef, useState } from "react";
// import Loader from '../Commons/Loader';
// import { Link } from 'react-router-dom'
// import $ from "jquery";
// import axiosInstance from "../../services/api";
// import "datatables.net";
// import "../../../node_modules/datatables.net-dt/css/dataTables.dataTables.min.css"
// import "datatables.net-responsive-dt";
// import "../../../node_modules/datatables.net-responsive-dt/css/responsive.dataTables.min.css";

// import { toast } from 'react-toastify';
// import { useMenu } from '../../context/MenuContext';

// function AutoProcessReport() {
//     const tableRef = useRef(null);
//     const fromDatepickerRef = useRef(null);
//     const dataTableInstance = useRef(null); // Store DataTable instance
//     const [userListingData, setUserListingData] = useState([]);
//     const [fromDate, setFromDate] = useState("");
//     const [successMessage, setSuccessMessage] = useState(""); 
//     const [loading, setLoading] = useState(true);
//     const menuArr = useMenu();
//     console.log("fromDate: ", fromDate)
    
//     // Destroy DataTable properly
//     const destroyDataTable = () => {
//         if (dataTableInstance.current) {
//             dataTableInstance.current.destroy();
//             dataTableInstance.current = null;
//         }
//     };

//     const fetchData = async (dateParam) => {
//         const dateToUse = dateParam || fromDate;
//         if (!dateToUse) return;
        
//         try {
//             const response = await axiosInstance.get('report/auto-process/process-details', {
//                 params: { date: dateToUse }
//             });
//             setUserListingData(response.data.data || []);
//         } catch (error) {
//             console.error('Error fetching data:', error);
//         } finally {
//             setLoading(false);
//         }
//     };

//     // Initialize or reinitialize DataTable
//     useEffect(() => {
//         if (userListingData.length > 0 && tableRef.current) {
//             // Destroy existing instance first
//             destroyDataTable();

//             // Small delay to ensure DOM is ready
//             dataTableInstance.current = $(tableRef.current).DataTable({
//                     destroy: true,
//                     paging: true,
//                     searching: true,
//                     lengthChange: true,
//                     ordering: true,
//                     responsive: true,
//                     autoWidth: false,
//                     columnDefs: [
//                         { targets: 1, responsivePriority: 1 },
//                         { targets: 6, responsivePriority: 2 },
//                         { targets: [1, 2, 3, 4, 5], responsivePriority: 3 }
//                     ],
//                     columns: [
//                         { title: "Hotel Id" },
//                         { title: "Report Date" },
//                         { title: "Process At" },
//                         { title: "Updated At" },
//                         { title: "Updated By"},
//                         { title: "Status" },
//                         { title: "Operations" },
//                         { title: "Send Details", orderable: false }
//                     ]
//                 });
//         } else if (userListingData.length === 0 && tableRef.current) {
//             // Destroy DataTable when no data
//             destroyDataTable();
//         }

//         return () => {
//             destroyDataTable();
//         };
//     }, [userListingData]);

//     // Handle window resize
//     useEffect(() => {
//         const handleResize = () => {
//             if (dataTableInstance.current) {
//                 dataTableInstance.current.columns.adjust().responsive.recalc();
//             }
//         };
//         window.addEventListener("resize", handleResize);
//         return () => {
//             window.removeEventListener("resize", handleResize);
//         };
//     }, []);

//     // Initialize datepicker
//     useEffect(() => {
//         const today = new Date();
//         const defaultFrom = new Date(today.getFullYear(), today.getMonth(), 0);
//         const formattedFrom = `${defaultFrom.getFullYear()}-${String(defaultFrom.getMonth() + 1).padStart(2, '0')}-${String(defaultFrom.getDate()).padStart(2, '0')}`;

//         setFromDate(formattedFrom);

//         setTimeout(() => {
//             $(fromDatepickerRef.current).val(
//                 defaultFrom.toLocaleString('default', { month: 'long', year: 'numeric' })
//             );
//         }, 0);

//         $(fromDatepickerRef.current).datepicker("destroy").datepicker({
//             changeMonth: true,
//             changeYear: true,
//             showButtonPanel: true,
//             dateFormat: "MM yy",
//             defaultDate: defaultFrom,
//             maxDate: defaultFrom,
//             onClose: function (dateText, inst) {
//                 const month = inst.selectedMonth;
//                 const year = inst.selectedYear;
//                 if (!isNaN(month) && !isNaN(year)) {
//                     const selectedDate = new Date(year, month + 1, 0);
//                     const formatted = `${selectedDate.getFullYear()}-${String(selectedDate.getMonth() + 1).padStart(2, '0')}-${String(selectedDate.getDate()).padStart(2, '0')}`;

//                     setFromDate(formatted);
//                     $(this).val(selectedDate.toLocaleString('default', { month: 'long', year: 'numeric' }));
                    
//                     // Destroy DataTable before fetching new data
//                     destroyDataTable();
//                     fetchData(formatted);
//                 }
//             },
//             beforeShow: function (input) {
//                 setTimeout(() => {
//                     $(input).datepicker("widget").addClass("month-year-picker");
//                 }, 0);
//             }
//         });

//         return () => {
//             $(fromDatepickerRef.current).datepicker("destroy");
//         };
//     }, []);

//     // Initial data fetch
//     useEffect(() => {
//         if (fromDate) {
//             fetchData();
//         }
//     }, [fromDate]);

   

//     const menuArrNw = menuArr.menuArr;
//     const checkAddUser = () => {
//         return menuArrNw.some(menu =>
//             menu.subMenus.some(subMenu => subMenu.id === "add-user")
//         );
//     };
//     const showAddUser = checkAddUser();

    

//     const handleChangeEnableToggle = async (item) => {
//         try {
//             const updated = !item.verified;
//             const response = await axiosInstance.post('report/auto-process/update-status', {
//                 hotelId: item.id,
//                 dateStr: fromDate,
//                 verified: item.verified
//             });

//             setUserListingData(prev =>
//                 prev.map(u => u.id === item.id ? { ...u, verified: updated } : u)
//             );
            
//             if (response.data.status.code === 200) {
//                 toast.success("Report reprocessed successfully!");
//             } else {
//                 toast.error(response.data.status.message || "Failed to reprocess report");
//             }
//         } catch (err) {
//             console.error("Error updating verified:", err);
//         }
//     };

//     const handleReprocessReport = async (item) => {
//         try {
//             const response = await axiosInstance.post('report/auto-process/reprocess', {
//                 hotelId: item.id,
//                 reportDate: fromDate
//             });

//             if (response.data.status.code === 200) {
//                 toast.success("Report reprocessed successfully!");
//                 fetchData();
//             } else {
//                 toast.error(response.data.status.message || "Failed to reprocess report");
//             }
//         } catch (error) {
//             console.error("Error reprocessing report:", error);
//             toast.error("Something went wrong!");
//         }
//     };

//     return (
//         <>
//         {loading && <Loader />} 
//         <div className="content-header">
//             <div className="container-fluid">
//                 <div className="row mb-2">
//                     <div className="col-sm-6 title-mob">
//                         <h1 className="m-0">Auto Process Report</h1>
//                         {showAddUser && <Link className="btn btn-primary submit-btn" to="/add-user">Add User</Link>}
//                     </div>
//                     <div className="col-sm-6">
//                         <ol className="breadcrumb float-sm-right">
//                             <li className="breadcrumb-item"><Link to="/dashboard">Dashboard</Link></li>
//                             <li className="breadcrumb-item active">Auto Process Report</li>
//                         </ol>
//                     </div>
//                 </div>
//             </div>
//         </div>
//         <section className="content">
//             <div className="container-fluid border-top pt-4">
//                 <div className='usage-report-top'>
//                     <div className='row'>
//                         <div className="col-lg-3">
//                             <div className='form-group d-flex items-center'>
//                                 <input type="text" placeholder="Select Date" className='input-fld' ref={fromDatepickerRef}/>
//                             </div>
//                         </div>
//                     </div>
//                 </div>
//                 <table ref={tableRef} className="display styled-table user-table autoprocess-table">
//                     <thead>
//                         <tr>
//                             <th>Hotel Id</th>
//                             <th>Report Date</th>
//                             <th>Process At</th>
//                             <th>Updated At</th>
//                             <th>Updated By</th>
//                             <th>Status</th>
//                             <th>Operations</th>
//                             <th>Send Details</th>
//                         </tr>
//                     </thead>
//                     <tbody>
//                         {userListingData.length > 0 ? userListingData.map((item, index) => (
//                             <tr key={index}>
//                                 <td>{item.hotelId}</td>
//                                 <td>{item.reportDate}</td>
//                                 <td>{item.processedAt}</td>
//                                 <td>{item.updatedAt}</td>
//                                 <td>{item.updatedByEmail}</td>
//                                 <td>
//                                     <label className="switch">
//                                         <input 
//                                             type="checkbox" 
//                                             checked={item.verified === true}
//                                             onChange={() => handleChangeEnableToggle(item)}
//                                         />
//                                         <span className="slider"></span>
//                                     </label>
//                                 </td>
//                                 <td>
//                                     <a 
//                                         href={item.reportPath} 
//                                         target="_blank" 
//                                         rel="noopener noreferrer" 
//                                         className="action-link edit"
//                                         title="Download Report"
//                                     >
//                                         <i className="nav-icon fas fa-download"></i>
//                                     </a>
//                                     <a 
//                                         onClick={() => handleReprocessReport(item)} 
//                                         className="action-link ml-2 edit reset-link" 
//                                         title="Reprocess Report"
//                                     >
//                                         <i className="nav-icon fas fa-sync-alt"></i>
//                                     </a>
//                                 </td>
//                                 <td>
//                                     <table>
//                                         <thead>
//                                             <tr>
//                                                 <th>Send To</th>
//                                                 <th>Send At</th>
//                                                 <th>Success</th>
//                                             </tr>
//                                         </thead>
//                                         <tbody>
//                                             {item.sendDetails.map((sd, idx) => (
//                                                 <tr key={idx}>
//                                                     <td>{sd.sendTo}</td>
//                                                     <td>{sd.sendAt}</td>
//                                                     <td>{sd.success ? '✅' : '❌'}</td>
//                                                 </tr>
//                                             ))}
//                                         </tbody>
//                                     </table>
//                                 </td>
//                             </tr>
//                         )) : (
//                             <tr>
//                                 <td colSpan="8" style={{textAlign: 'center', padding: '20px'}}>
//                                     No data available
//                                 </td>
//                             </tr>
//                         )}
//                     </tbody>
//                 </table>
//             </div>
//         </section>
//         </>
//     );
// }

// export default AutoProcessReport;


import React, { useEffect, useRef, useState } from "react";
import Loader from "../Commons/Loader";
import $ from "jquery";
import axiosInstance from "../../services/api";
import "datatables.net";
import "datatables.net-responsive-dt";
import "datatables.net-dt/css/dataTables.dataTables.min.css";
import "datatables.net-responsive-dt/css/responsive.dataTables.min.css";
import { toast } from "react-toastify";
import Swal from "sweetalert2";

function AutoProcessReport() {
    const tableElement = useRef(null);
    const monthPickerRef = useRef(null);
    const dataTableRef = useRef(null);

    const [reportData, setReportData] = useState([]);
    const [selectedMonth, setSelectedMonth] = useState("");
    const [isLoading, setIsLoading] = useState(true);

    // Destroy DataTable instance safely
    const destroyTable = () => {
        if (dataTableRef.current) {
            dataTableRef.current.destroy();
            dataTableRef.current = null;
        }
    };

    // Fetch report data
    const getReportData = async (dateValue) => {
        const finalDate = dateValue || selectedMonth;
        if (!finalDate) return;

        try {
            const response = await axiosInstance.get("report/auto-process/process-details", {
                params: { date: finalDate }
            });
            setReportData(response.data.data || []);
        } catch (error) {
            console.error("Error fetching report data:", error);
        } finally {
            setIsLoading(false);
        }
    };

    // Initialize DataTable after data load
    useEffect(() => {
        if (reportData.length > 0 && tableElement.current) {
            destroyTable();
            dataTableRef.current = $(tableElement.current).DataTable({
                destroy: true,
                paging: true,
                searching: true,
                lengthChange: true,
                ordering: true,
                responsive: true,
                autoWidth: false,
                columnDefs: [
                    { targets: 1, responsivePriority: 1 },
                    { targets: 6, responsivePriority: 2 },
                    { targets: [1, 2, 3, 4, 5], responsivePriority: 3 }
                ],
            });
        } else if (reportData.length === 0) {
            destroyTable();
        }

        return () => destroyTable();
    }, [reportData]);

    // Recalculate columns on resize
    useEffect(() => {
        const handleResize = () => {
            if (dataTableRef.current) {
                dataTableRef.current.columns.adjust().responsive.recalc();
            }
        };
        window.addEventListener("resize", handleResize);
        return () => window.removeEventListener("resize", handleResize);
    }, []);

    // Initialize month-year datepicker
    useEffect(() => {
        const today = new Date();
        const defaultDate = new Date(today.getFullYear(), today.getMonth(), 0);
        const formattedDate = `${defaultDate.getFullYear()}-${String(defaultDate.getMonth() + 1).padStart(2, "0")}-${String(defaultDate.getDate()).padStart(2, "0")}`;
        setSelectedMonth(formattedDate);

        setTimeout(() => {
            $(monthPickerRef.current).val(defaultDate.toLocaleString("default", { month: "long", year: "numeric" }));
        }, 0);

        $(monthPickerRef.current)
            .datepicker("destroy")
            .datepicker({
                changeMonth: true,
                changeYear: true,
                showButtonPanel: true,
                dateFormat: "MM yy",
                defaultDate: defaultDate,
                maxDate: defaultDate,
                onClose: function (dateText, inst) {
                    const { selectedMonth: m, selectedYear: y } = inst;
                    if (!isNaN(m) && !isNaN(y)) {
                        const pickedDate = new Date(y, m + 1, 0);
                        const formatted = `${pickedDate.getFullYear()}-${String(pickedDate.getMonth() + 1).padStart(2, "0")}-${String(pickedDate.getDate()).padStart(2, "0")}`;
                        setSelectedMonth(formatted);
                        $(this).val(pickedDate.toLocaleString("default", { month: "long", year: "numeric" }));

                        destroyTable();
                        getReportData(formatted);
                    }
                },
                beforeShow: function (input) {
                    setTimeout(() => $(input).datepicker("widget").addClass("month-year-picker"), 0);
                },
            });

        return () => $(monthPickerRef.current).datepicker("destroy");
    }, []);

    // Initial data fetch
    useEffect(() => {
        if (selectedMonth) getReportData();
    }, [selectedMonth]);

    // Toggle verified status
    const handleStatusToggle = async (row) => {

        const updatedVerified = !row.verified;

        const confirmResult = await Swal.fire({
            title: "Are you sure?",
            text: `You are about to mark this report as ${updatedVerified ? "Verified" : "Unverified"}.`,
            icon: "warning",
            showCancelButton: true,
            confirmButtonText: "Yes, proceed",
            cancelButtonText: "Cancel"
        });
        if (!confirmResult.isConfirmed) return;

        try {
            const response = await axiosInstance.post("report/auto-process/update-status", {
                hotelId: row.hotelId,
                dateStr: selectedMonth,
                reportCorrect: updatedVerified
            });

            setReportData((prev) =>
                prev.map((r) => (r.id === row.id ? { ...r, verified: updatedVerified } : r))
            );

            if (response.data.status.code === 200) {
                  Swal.fire("Updated!", response.data.status.message , "success");
            } else {
                 Swal.fire("Error", response.data.status.message || "Failed to update status", "error");
            }
        } catch (err) {
            console.error("Status update error:", err);
             Swal.fire("Error", "Something went wrong!", "error");
        }
    };

    // Reprocess report
    const handleReprocess = async (row) => {
         const confirmResult = await Swal.fire({
            title: "Are you sure?",
            text: "This will reprocess the report. It might take a while.",
            icon: "question",
            showCancelButton: true,
            confirmButtonText: "Yes, reprocess it!",
            cancelButtonText: "Cancel"
        });

        if (!confirmResult.isConfirmed) return;
        Swal.fire({
            title: "Reprocessing...",
            text: "Please wait while the report is being reprocessed.",
            allowOutsideClick: false,
            allowEscapeKey: false,
            didOpen: () => {
                Swal.showLoading();
            },
        });
        try {
            const response = await axiosInstance.post("report/auto-process/re-process", {
                hotelId: row.hotelId,
                reportDate: selectedMonth
            });
            Swal.close(); // hide loader before showing result
            if (response.data.status.code === 200) {
                 Swal.fire("Success!", response.data.status.message, "success");
                getReportData();
            } else {
                Swal.fire("Error", response.data.status.message || "Failed to reprocess", "error");
            }
        } catch (error) {
            console.error("Error reprocessing report:", error);
            Swal.close(); // hide loader before showing result
            Swal.fire("Error", "Something went wrong!", "error");
        }
    };

    return (
        <>
            {isLoading && <Loader />}
            <div className="content-header">
                <div className="container-fluid">
                    <div className="row mb-2">
                        <div className="col-sm-6">
                            <h1 className="m-0">Auto Process Report</h1>
                        </div>
                    </div>
                </div>
            </div>

            <section className="content">
                <div className="container-fluid border-top pt-4">
                    <div className="row">
                        <div className="col-lg-3">
                            <div className="form-group d-flex items-center">
                                <input
                                    type="text"
                                    placeholder="Select Month"
                                    className="input-fld"
                                    ref={monthPickerRef}
                                />
                            </div>
                        </div>
                    </div>

                    <table ref={tableElement} className="display styled-table user-table autoprocess-table">
                        <thead>
                            <tr>
                                <th>Hotel Id</th>
                                <th>Hotel Name</th>
                                <th>Report Date</th>
                                <th>Process At</th>
                                <th>Updated At</th>
                                <th>Updated By</th>
                                <th>Status</th>
                                <th>Operations</th>
                                <th>Send Details</th>
                            </tr>
                        </thead>
                        <tbody>
                            {reportData.length > 0 ? (
                                reportData.map((row, idx) => (
                                    <tr key={idx}>
                                        <td>{row.hotelId}</td>
                                        <td>{row.hotelName}</td>
                                        <td>{row.reportDate}</td>
                                        <td>{row.processedAt}</td>
                                        <td>{row.updatedAt}</td>
                                        <td>{row.updatedByEmail}</td>
                                        <td>
                                            <label className="switch">
                                                <input
                                                    type="checkbox"
                                                    checked={row.verified === true}
                                                    onChange={() => handleStatusToggle(row)}
                                                />
                                                <span className="slider"></span>
                                            </label>
                                        </td>
                                        <td>
                                            <a
                                                href={row.reportPath}
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="action-link edit"
                                                title="Download Report"
                                            >
                                                <i className="nav-icon fas fa-download"></i>
                                            </a>
                                            <a
                                                onClick={() => handleReprocess(row)}
                                                className="action-link ml-2 edit reset-link"
                                                title="Reprocess Report"
                                            >
                                                <i className="nav-icon fas fa-sync-alt"></i>
                                            </a>
                                        </td>
                                        <td>
                                            <table>
                                                <thead>
                                                    <tr>
                                                        <th>Send To</th>
                                                        <th>Send At</th>
                                                        <th>Success</th>
                                                    </tr>
                                                </thead>
                                                <tbody>
                                                    {row.sendDetails.map((sd, id2) => (
                                                        <tr key={id2}>
                                                            <td>{sd.sendTo}</td>
                                                            <td>{sd.sendAt}</td>
                                                            <td>{sd.success ? "✅" : "❌"}</td>
                                                        </tr>
                                                    ))}
                                                </tbody>
                                            </table>
                                        </td>
                                    </tr>
                                ))
                            ) : (
                                <tr>
                                    <td colSpan="8" style={{ textAlign: "center", padding: "20px" }}>
                                        No data available
                                    </td>
                                </tr>
                            )}
                        </tbody>
                    </table>
                </div>
            </section>
        </>
    );
}

export default AutoProcessReport;
